<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <div style="display:flex">
        <el-form-item
          label="广告目标账户"
          prop="account_id"
        >
          <div style="display:flex">

            <div>
              <el-button
                type="success"
                size="mini"
                @click="selectID"
              >选择</el-button>
            </div>
            <div><el-button
              v-show="merchant_ids.length!==0"
              type="warning"
              size="mini"
              @click="merchant_ids = []"
            >清空</el-button></div>
            <div
              v-if="merchant_ids.length!==0"
              style="max-height: 550px;
            overflow-y: scroll;position: relative;"
            >
              <el-tag
                v-for="itemr,index in merchant_ids"
                :key="index"
                style="margin-right:10px;margin-bottom:5px"
                closable
                :type="itemr.account_id+''"
                @close="rightclick2(index)"
              >
                {{ itemr.account_name }}
              </el-tag>
            </div>
          </div>
        </el-form-item>

      </div>

      <el-form-item style="margin-top: 50px;margin-left: 400px;">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择广告目标账户"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleId"
      width="1100px"
      append-to-body
    >
      <accoutIdDialog
        ref="id"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>
<script>
// import accoutIdDialog from '../../property/components/accoutIdDialog.vue'
import accoutIdDialog from './detailList.vue'

// import { alldatalist } from '@/api/providerAccountManagement/servicePorviderList.js'

export default {
  components: {
    accoutIdDialog
  },
  data() {
    return {
      ruleForm: {
        account_ids: ''
      },
      wechatname: '',
      rules: {
        account_ids: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      loading: false,
      tableData: {
        list: [],
        total: 10
      },
      account_name: '',
      dialogVisible: false,
      check: undefined,
      wechatVisible: false,
      dialogVisibler: false,
      dialogMerchant: false,
      arrs: [],
      merchant_ids: [],
      typer: null,
      idr: null,
      dialogVisibletwo: false,
      dialogVisibleId: false
    }
  },
  // 页面初始化挂载dom
  mounted() {
    console.log('111')
    // this.$nextTick(() => {
    //   //  执行echarts方法
    //   this.getLoadEcharts()
    // })
    // this.getLoadEcharts()
  },
  methods: {
    selectID() {
      this.dialogVisibleId = true
      this.$nextTick(() => {
        this.$refs.id.sendr(this.merchant_ids, 1)
      })
    },
    bandarr(arr) {
      this.merchant_ids = arr
      // this.ruleForm.account_ids = []
      // arr.forEach(element => {
      //   this.ruleForm.account_ids.push(element.account_id)
      // })
      this.dialogVisibleId = false
    },
    merchantchat() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.ruleForm.account_ids = []
          if (this.merchant_ids.length === 0) {
            return this.$message.info('请选择广告目标账户')
          }
          this.merchant_ids.forEach(element => {
            this.ruleForm.account_ids.push(element.account_id)
          })
          console.log(' this.ruleForm.agents_password :', this.ruleForm)
          this.$emit('submit', this.ruleForm, () => {
            this.ruleForm = {
              account_ids: ''
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    wechatclick() {
      this.wechatVisible = true
      this.$nextTick(() => {
        this.$refs.wechatview.send()
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async changewr(val, item) {
      console.log(val, item)
      // await setReceiveMiniprogram({
      //   receive_miniprogram: val,
      //   id: item.id
      // })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async send(row, query) {
      console.log('---', row, query)

      // eslint-disable-next-line eqeqeq
      console.log('JSON', JSON.stringify(query) == JSON.stringify({}))
      if (JSON.stringify(query) === JSON.stringify({})) {
        this.merchant_ids = []
      } else {
        this.merchant_ids = [
          {
            account_id: Number(query.account_id),
            account_name: query.account_name
          }
        ]
      }
      console.log(this.merchant_ids)
    },
    rightclick(index) {
      this.arrs.splice(index, 1)
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.pic_img {
  width: 95px;
}
</style>
